const initBaliMap = () => {
  const mapElement = document.querySelector(".bt-map-art");
  if (!mapElement || !window.L) return;

  let locations;
  try {
    locations = JSON.parse(mapElement.dataset.locations || "[]");
  } catch (error) {
    return;
  }

  if (!locations.length) return;

  const map = window.L.map(mapElement.querySelector(".bt-map-canvas"), {
    scrollWheelZoom: false,
    zoomControl: false,
    attributionControl: true,
  }).setView([-8.45, 115.28], 9);

  window.L.control.zoom({ position: "bottomright" }).addTo(map);
  window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors',
  }).addTo(map);

  locations.forEach((location) => {
    const marker = window.L.marker([location.coordinates[1], location.coordinates[0]], {
      icon: window.L.divIcon({
        className: "bt-leaflet-marker-wrap",
        html: `<button class="bt-leaflet-marker" type="button" aria-label="Show ${location.name}"><img src="${location.image}" alt=""><span>${location.name}</span></button>`,
        iconSize: [0, 0],
      }),
    });

    marker.bindPopup(`
      <article class="bt-map-popup">
        <img src="${location.image}" alt="${location.name} in Bali">
        <div class="bt-map-popup__body">
          <p class="bt-eyebrow">Private driver service</p>
          <h3>${location.name}</h3>
          <p>${location.description}</p>
          <a class="bt-dark-link bt-map-popup__cta" href="${mapElement.dataset.placesUrl}">Plan this route <span>↗</span></a>
        </div>
      </article>
    `, { maxWidth: 280, className: "bt-map-popup-container" });

    marker.addTo(map);
  });

  mapElement.classList.add("is-leaflet-ready");
};

document.addEventListener("DOMContentLoaded", initBaliMap);
